import { Component, OnDestroy, OnInit, ChangeDetectorRef, ViewChild, NgZone } from '@angular/core';
import { IssueTypeService } from 'app/services/issuetypes/issuetypes.service';
import { DataTableDirective } from 'angular-datatables';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { TranslatorService } from '../../services/common/translator.service';
import { ActivatedRoute, Router } from '@angular/router';

import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { AccountService } from '../../services/accounts/accounts.service';

// Moment timezone
import * as Moment from 'moment';
import * as mTZ from 'moment-timezone';
window['moment'] = Moment;
mTZ()

@Component({
  selector: 'fh-accounts-with-use',
  templateUrl: 'accountsWithUse.template.html',
  styleUrls: ['accountsWithUse.template.css']
})
export class AccountWithUseViewComponent implements OnInit, OnDestroy {
  token: string;
  countrySelect = false;

  dtOptions = {};
  loading = false;
  permissions: {};

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  dropdown_IssueType = '';
  dropdown_DeviceType = '';
  dropdown_Severity = '';
  languageLoaded: boolean;
  showOnlyActive = true;
  timezoneIana: string;
  searchTerm: any;

  constructor(private ngZone: NgZone, private localeService: BsLocaleService, private route: ActivatedRoute, private router: Router, private translatorService: TranslatorService, private translateService: TranslateService, private cd: ChangeDetectorRef, private issueTypeService: IssueTypeService, private authenticationService: AuthenticationService, private accountService: AccountService) {
    const that = this;

    this.timezoneIana = this.authenticationService.getTimeZoneIana();
    this.token = this.authenticationService.getAuthToken();
    this.permissions = this.authenticationService.permissions;

    this.showOnlyActive = !this.permissions['HasWasl'];

  }

  seachChanged(value) {
    console.log('Search changed');
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.search(value).draw();
    });
  }

  checkFilters() {
    this.fireFilter('init');
  }

  fireFilter(event): void {

    if (event != null) {
      console.log('Fire update');
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

        if (this.showOnlyActive === true) {
          dtInstance.column('isActive:name').search('true');
        } else {
          dtInstance.column('isActive:name').search('');
        }

        // Fire the request
        dtInstance.draw();
      });
    }
  }


  ngOnDestroy(): void {
    // We remove the last function in the global ext search array so we do not add the fn each time the component is drawn
    // /!\ This is not the ideal solution as other components may add other search function in this array, so be careful when
    // handling this global variable
    $.fn['dataTable'].ext.search.pop();

    // Had to reset the array...
    $.fn['dataTable'].ext.search = [];
  }


  ngOnInit(): void {
    this.translateService.get('general.date').subscribe(value => {
      this.languageLoaded = true; this.initGrid();
    });
  }

  initGrid(): void {
    window['my'] = window['my'] || {};
    window['my'].namespace = window['my'].namespace || {};

    const that = this;

    $.fn['dataTable'].ext.search.pop();

    this.loading = true;

    const hideForWasl = !this.permissions['HasWasl'];

    this.dtOptions = {
      pagingType: 'simple_numbers',
      serverSide: false,
      processing: false,
      scrollX: true,
      colReorder: {fixedColumnsLeft: 1},
      order: [[2, 'desc']],
      stateSave: true,
      stateSaveCallback: function (settings, data) {
        localStorage.setItem('Columns_' + that.constructor.name, JSON.stringify(data));
      },
      stateLoadCallback: function () {
        try {
          const columnSettings = JSON.parse(localStorage.getItem('Columns_' + that.constructor.name));
          that.searchTerm = columnSettings && columnSettings.search && columnSettings.search.search;
          return columnSettings;
        } catch (e) {
          console.log(e);
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
        $('.dataTables_info').html(this.translateService.instant('grid.loadingData'));

        const accountsCall = this.permissions['HasWasl']
          ? this.accountService.getAccountsWithUseWasl()
          : this.accountService.getAccountsWithUse()

        accountsCall.subscribe(resp => {
          callback({
            recordsTotal: resp.length,
            recordsFiltered: resp.length,
            data: resp
          });
        });
      },
      initComplete: function (settings, json) {
        console.log('init complete');
        that.checkFilters();
        that.loading = false;
      },
      colVis: {
        restore: this.translateService.instant('general.restore'),
        showAll: this.translateService.instant('general.showAll'),
        showNone: this.translateService.instant('general.hideAll'),
        exclude: ['id']
      },
      columns: [{
        data: 'id',
        orderable: false,
        title: '',
        width: '20',
        render: function (data, type, row) {
          return '<a class=\'btn btn-primary btn-outline btn-grid\' href=\'/#/AccountDetails/Index/' + data + '\'><i class=\'fas fa-fw fa-info\'></i> <span class="hidden-sm hidden-xs">Details</span></a>';
        }
      },
      {
        data: 'name',
        title: this.translateService.instant('general.name')
      },
      {
        data: 'userCount',
        title: this.translateService.instant('general.userCount')
      },
      {
        data: 'platformCount',
        title: this.translateService.instant('general.platformCount'),
        visible: hideForWasl
      },
      {
        data: 'deviceCount',
        title: hideForWasl ? this.translateService.instant('general.deviceCount') : this.translateService.instant('general.devices'),
      },
      {
        data: 'status',
        title: this.translateService.instant('general.accountStatus'),
        visible: hideForWasl,
        render: function (data, type, row) {
          return data ? that.translatorService.translate(data.toString(), 'enums.accountStatus') : '-';
        }
      },
      {
        data: 'createdDate',
        title: this.translateService.instant('general.created'),
        visible: hideForWasl,
        render: function (data, type, row) {
          if (type === 'display') {
            const date = Moment.utc(data)['tz'](that.timezoneIana);
            return date.format('lll')
          }
          return data;
        }
      }
      ],
      pageLength: 10,
      language: {
        'lengthMenu': this.translateService.instant('grid.lengthmenu'),
        'zeroRecords': this.translateService.instant('grid.empty'),
        'info': this.translateService.instant('grid.info'),
        'infoEmpty': this.translateService.instant('grid.infoempty'),
        'infoFiltered': this.translateService.instant('grid.infofiltered'),
        'search': this.translateService.instant('grid.search'),
        'infoThousands': '.',
        'loadingRecords': this.translateService.instant('grid.loadingrecords'),
        'paginate': {
          'first': this.translateService.instant('grid.first'),
          'last': this.translateService.instant('grid.last'),
          'next': this.translateService.instant('grid.next'),
          'previous': this.translateService.instant('grid.previous'),
        },
        'aria': {
          'sortAscending': this.translateService.instant('grid.sortasc'),
          'sortDescending': this.translateService.instant('grid.sortdesc'),
        }
      },
    };

    if (this.permissions['HasWasl']) {

      this.dtOptions['columns'].push({
        name: 'waslCompany',
        data: 'properties',
        title: `<div><span style='padding-left: 0px !important'>${this.translateService.instant('general.registered')}<i style='padding-left: 5px;' class='fa fa-info-circle' title='${this.translateService.instant('general.registeredDesc')}'></span></div>`,
        render: (data, type, row) => {
          return Boolean(data && data.wasl && data.wasl.referenceKey) ? this.translateService.instant('general.yes') : this.translateService.instant('general.no')
        }
      });
      this.dtOptions['columns'].push({
        data: 'assetCount',
        title: this.translateService.instant('general.assets'),
      });
      this.dtOptions['columns'].push({
        data: 'waslAssetCount',
        title: `<div><span style='padding-left: 0px !important'>${this.translateService.instant('general.waslAsset')}<i style='padding-left: 5px;' class='fa fa-info-circle' title='${this.translateService.instant('general.waslAssetDesc')}'></span></div>`,
      });
      this.dtOptions['columns'].push({
        data: 'driverCount',
        title: this.translateService.instant('general.drivers'),
      });
      this.dtOptions['columns'].push({
        data: 'waslDriverCount',
        title: `<div><span style='padding-left: 0px !important'>${this.translateService.instant('general.waslDriver')}<i style='padding-left: 5px;' class='fa fa-info-circle' title='${this.translateService.instant('general.waslDriverDesc')}'></span></div>`,
      });
      this.dtOptions['columns'].push({
        data: 'waslFailedCount',
        title: `<div><span style='padding-left: 0px !important'>${this.translateService.instant('general.inquiryIssues')}<i style='padding-left: 5px;' class='fa fa-info-circle' title='${this.translateService.instant('general.inquiryIssuesDesc')}'></span></div>`,
      });
      this.dtOptions['columns'].push({
        data: 'waslSuccessCount',
        visible: false,
        title: `<div><span style='padding-left: 0px !important'>${this.translateService.instant('general.inquiryValid')}<i style='padding-left: 5px;' class='fa fa-info-circle' title='${this.translateService.instant('general.inquiryValidDesc')}'></span></div>`,
      });
    } else {

      this.dtOptions['columns'].push(
        {
          data: 'date',
          title: this.translateService.instant('general.issueDate'),
          render: function (data, type, row) {
            if (type === 'display') {
              const date = Moment.utc(data)['tz'](that.timezoneIana);
              return date.format('lll')
            }
            return data;
          }
        },
        {
          data: 'jobCount',
          title: this.translateService.instant('general.jobCount')
        },
        {
          name: 'isActive',
          data: 'isActive',
          title: this.translateService.instant('general.active'),
          visible: false,
          // render: function (data, type, row) {
          //   return data === true ? '<i class="fa-fw fa-2x fa-check-square far" style=" font-size: 1.3em;"></i>' : '<i class="fa-fw fa-2x fa-square far" style=" font-size: 1.3em;"></i>';
          // }
        },
        {
          data: 'issueCount',
          title: this.translateService.instant('general.issueCount')
        });

    }
  }
}
